// extracted by mini-css-extract-plugin
export default {"container":"Map_container__LGoGe","marker":"Map_marker__vm1ZM"};